
namespace GeniuzPOS.InventoryReport {

    @Serenity.Decorators.registerClass()
    export class IcReport02Dialog extends Serenity.EntityDialog<IcReport02Row, any> {
        protected getFormKey() { return IcReport02Form.formKey; }
        protected getIdProperty() { return IcReport02Row.idProperty; }
        protected getLocalTextPrefix() { return IcReport02Row.localTextPrefix; }
        protected getNameProperty() { return IcReport02Row.nameProperty; }
        protected getService() { return IcReport02Service.baseUrl; }
        protected getDeletePermission() { return IcReport02Row.deletePermission; }
        protected getInsertPermission() { return IcReport02Row.insertPermission; }
        protected getUpdatePermission() { return IcReport02Row.updatePermission; }

        protected form = new IcReport02Form(this.idPrefix);
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

            return buttons;
        }
    }
}